import { HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST } from "./heating-system-exchange-system-list";
export const HEATING_SYSTEM_EXCHANGE_SYSTEM_BY_KEY = Object.fromEntries(HEATING_SYSTEM_EXCHANGE_SYSTEM_LIST.map((system) => [system.key, system]));
